module.exports = __webpack_public_path__ + "img/creditos.ff5d7b1d.png";